function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { stringValue } from 'vega-util';
import { VL_SELECTION_RESOLVE } from '.';
import { isScaleChannel } from '../../channel';
import * as log from '../../log';
import { hasContinuousDomain } from '../../scale';
import { isLayerModel } from '../model';
import { replacePathInField } from '../../util';
var scaleBindings = {
  defined: function defined(selCmpt) {
    return selCmpt.type === 'interval' && selCmpt.resolve === 'global' && selCmpt.bind && selCmpt.bind === 'scales';
  },
  parse: function parse(model, selCmpt) {
    var bound = selCmpt.scales = [];
    var _iterator = _createForOfIteratorHelper(selCmpt.project.items),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var proj = _step.value;
        var channel = proj.channel;
        if (!isScaleChannel(channel)) {
          continue;
        }
        var scale = model.getScaleComponent(channel);
        var scaleType = scale ? scale.get('type') : undefined;
        if (scaleType == 'sequential') {
          log.warn(log.message.SEQUENTIAL_SCALE_DEPRECATED);
        }
        if (!scale || !hasContinuousDomain(scaleType)) {
          log.warn(log.message.SCALE_BINDINGS_CONTINUOUS);
          continue;
        }
        scale.set('selectionExtent', {
          param: selCmpt.name,
          field: proj.field
        }, true);
        bound.push(proj);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  topLevelSignals: function topLevelSignals(model, selCmpt, signals) {
    var bound = selCmpt.scales.filter(function (proj) {
      return signals.filter(function (s) {
        return s.name === proj.signals.data;
      }).length === 0;
    });
    // Top-level signals are only needed for multiview displays and if this
    // view's top-level signals haven't already been generated.
    if (!model.parent || isTopLevelLayer(model) || bound.length === 0) {
      return signals;
    }
    // vlSelectionResolve does not account for the behavior of bound scales in
    // multiview displays. Each unit view adds a tuple to the store, but the
    // state of the selection is the unit selection most recently updated. This
    // state is captured by the top-level signals that we insert and "push
    // outer" to from within the units. We need to reassemble this state into
    // the top-level named signal, except no single selCmpt has a global view.
    var namedSg = signals.find(function (s) {
      return s.name === selCmpt.name;
    });
    var update = namedSg.update;
    if (update.includes(VL_SELECTION_RESOLVE)) {
      namedSg.update = "{".concat(bound.map(function (proj) {
        return "".concat(stringValue(replacePathInField(proj.field)), ": ").concat(proj.signals.data);
      }).join(', '), "}");
    } else {
      var _iterator2 = _createForOfIteratorHelper(bound),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var proj = _step2.value;
          var mapping = "".concat(stringValue(replacePathInField(proj.field)), ": ").concat(proj.signals.data);
          if (!update.includes(mapping)) {
            update = "".concat(update.substring(0, update.length - 1), ", ").concat(mapping, "}");
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      namedSg.update = update;
    }
    return signals.concat(bound.map(function (proj) {
      return {
        name: proj.signals.data
      };
    }));
  },
  signals: function signals(model, selCmpt, _signals) {
    // Nested signals need only push to top-level signals with multiview displays.
    if (model.parent && !isTopLevelLayer(model)) {
      var _iterator3 = _createForOfIteratorHelper(selCmpt.scales),
        _step3;
      try {
        var _loop = function _loop() {
          var proj = _step3.value;
          var signal = _signals.find(function (s) {
            return s.name === proj.signals.data;
          });
          signal.push = 'outer';
          delete signal.value;
          delete signal.update;
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    return _signals;
  }
};
export default scaleBindings;
export function domain(model, channel) {
  var scale = stringValue(model.scaleName(channel));
  return "domain(".concat(scale, ")");
}
function isTopLevelLayer(model) {
  return model.parent && isLayerModel(model.parent) && (!model.parent.parent || isTopLevelLayer(model.parent.parent));
}